import { useContext } from 'react';
import ChallengePortfolioContext from '@/components/ChallengePortfolio/ChallengePortfolioContext';
import ChallengeContext from '../../ChallengeContext';
import useApi from '@/lib/api/useApi';
import InnerPhaseSelect from './InnerPhaseSelect';
import type KanbanPhase from '@/lib/constants/KanbanPhase.enum';
import { type ChallengeWithoutRelations } from '@/lib/types';
import NewlySharedContext from '@/components/ChallengePortfolio/NormalView/NewlySharedChallenges/NewlySharedContext';
import PortfolioItemCloseBlockingContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemCloseBlockingContext';

const PhaseSelect = () => {
  const api = useApi();

  const [isNewlyShared, , setNewlySharedChallenges] =
    useContext(NewlySharedContext);
  const [, setChallengePortfolio] = useContext(ChallengePortfolioContext);
  const [challenge, setChallenge] = useContext(ChallengeContext);

  const { isPortfolioItemCloseBlocked, saveAllPendingPortfolioItemChanges } =
    useContext(PortfolioItemCloseBlockingContext);

  const savePhaseChange = async (phase: KanbanPhase): Promise<void> => {
    if (isPortfolioItemCloseBlocked) {
      await saveAllPendingPortfolioItemChanges();
    }

    const updatedChallenge = await api.put<ChallengeWithoutRelations>(
      `challenge-portfolio/challenges/${challenge.id}/phase`,
      {
        phase,
      },
    );

    setChallenge(challenge => {
      challenge.phase = updatedChallenge.phase;
      challenge.startDate = updatedChallenge.startDate;
      challenge.endDate = updatedChallenge.endDate;
    });

    if (isNewlyShared) {
      setNewlySharedChallenges(newlySharedChallenges => {
        newlySharedChallenges[challenge.id].phase = phase;
      });

      return;
    }

    setChallengePortfolio(challengePortfolio => {
      challengePortfolio.challenges[challenge.id].phase = phase;
    });
  };

  return (
    <InnerPhaseSelect
      originalPhase={challenge.phase}
      onSave={savePhaseChange}
    />
  );
};

export default PhaseSelect;
